import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';
import { store } from './store';
import Navbar from './components/Common/Navbar';
import { isAuthenticated } from './services/auth';
import './styles/App.css';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const RoutesPage = lazy(() => import('./pages/Routes'));
const VehiclesPage = lazy(() => import('./pages/Vehicles'));
const LogsPage = lazy(() => import('./pages/Logs'));
const Profile = lazy(() => import('./pages/Profile'));
const Settings = lazy(() => import('./pages/Settings'));
const Help = lazy(() => import('./pages/Help'));
const Login = lazy(() => import('./pages/Login'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#00e676' },
    secondary: { main: '#2196f3' },
    background: { default: '#0a1929', paper: '#1a2332' },
  },
});

function ProtectedLayout({ children }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <div className="app">
      <Navbar />
      <div className="main-content">{children}</div>
    </div>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route path="/" element={<ProtectedLayout><Dashboard /></ProtectedLayout>} />
      <Route path="/routes" element={<ProtectedLayout><RoutesPage /></ProtectedLayout>} />
      <Route path="/vehicles" element={<ProtectedLayout><VehiclesPage /></ProtectedLayout>} />
      <Route path="/logs" element={<ProtectedLayout><LogsPage /></ProtectedLayout>} />
      <Route path="/profile" element={<ProtectedLayout><Profile /></ProtectedLayout>} />
      <Route path="/settings" element={<ProtectedLayout><Settings /></ProtectedLayout>} />
      <Route path="/help" element={<ProtectedLayout><Help /></ProtectedLayout>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Suspense fallback={<div style={{ padding: 24, textAlign: 'center' }}>Loading...</div>}><AppRoutes /></Suspense>
          <Toaster position="bottom-right" />
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
